<template>
  <div class="page-content">
    <div class="menu-box sider">
      <div class="app-side">
        <div
          :class="['app-all',{select:app.type==='all'}]"
          @click="app.on.getList('all')"
        >
          <!-- <Icon
            type="md-apps"
            size="18"
          /> -->
          <span>全部应用</span>
        </div>
        <Tree
          v-if="tree.data.length"
          :data="tree.data"
          :render="tree.on.render"
        >
        </Tree>
      </div>
    </div>
    <div class="page-right">
      <div
        v-if="!app.loading"
        class="app-box"
      >
        <div
          v-for="(item,index) in app.list"
          :key="index"
          class="app-item"
          @click="goAppDetail(item)"
        >
          <img
            class="app-img"
            :src="item.productImage"
          >
          <div class="app-content">
            <div class="app-name">
              {{ item.saleName }}
            </div>
            <div class="app-intro-box">
              <div class="app-intro">
                {{ item.productMemo }}
              </div>
              <!-- <span
                class="go-detail"
                @click="goAppDetail(item)"
              >了解详情</span> -->
            </div>
          </div>
          <div class="app-footer">
            <div class="app-price">
              <span class="app-price-icon">¥</span>
              {{ item.salePrice|moneyFix }}
            </div>
          </div>
          <div
            v-if="!item.hasBuy"
            class="app-bottom"
          >
            <Button
              class="order-btn"
              @click.stop="goAppDetail(item)"
            >
              我要订购
            </Button>
          </div>
          <div
            v-if="item.hasBuy"
            class="app-bottom"
          >
            <div :class="['expire-time',{'expire-time-red':item.serviceEnd<nowDate}]">
              即将于{{ item.serviceEnd }} 到期
            </div>
            <Button
              class="order-btn"
              @click.stop="goAppOrder(item)"
            >
              续费
            </Button>
          </div>
        </div>
      </div>
      <!-- 加载数据时显示骨架屏幕 -->
      <Skeleton v-if="app.loading" />
      <div
        v-else-if="!app.list.length"
        style="text-align: center; color: #999;"
      >
        <img src="@/assets/images/empty.png">
        <div>暂无数据</div>
      </div>
      <div
        v-if="app.list.length"
        class="page-box"
      >
        <Page
          :total="app.total"
          :page-size="app.params.limit"
          :current="app.params.page"
          show-sizer
          :page-size-opts="[12,16,20,24]"
          @on-page-size-change="app.on.onPageSizeChange"
          @on-change="app.on['on-change']"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from './components/Skeleton';
import {Tree} from 'view-design';
import moment from 'moment';
export default {
  components: {
    Tree,
    Skeleton,
  },
  data(){
    return {
      nowDate: moment().add(30,'days').format('YYYY-MM-DD'),
      currentDetail: {},
      tree: {
        height: '',
        data: [],
        on: {

          render: (h, {data })=> {
            const html = [];

            // 名称
            const span = h('span', [
              // h('Icon', {
              //   props: {
              //     type: data.children && data.children.length ? 'ios-folder-outline' : 'ios-paper-outline',
              //   },
              //   style: {
              //     marginRight: '8px',
              //     display: 'inline-block',
              //     verticalAlign: 'middle',
              //   },
              // }),
              h('span',{
                style: {
                  display: 'inline-block',
                  width: '160px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  verticalAlign: 'middle',
                },
              },data.title),
            ]);
            html.push(span);
            // 是否有子集
            const isHasChildren = !data.row.subList || !data.row.subList.length;
            // 是否为选中的项
            let selectStyle = { };
            if (this.currentDetail.id && this.currentDetail.id=== data.row.id){
              selectStyle = {
                color: '#2589ff',
                // backgroundColor: '#dfeeff',
              };

            }
            return h('div', {
              attrs: {
                class: isHasChildren?'children-title':'',
              },
              style: {
                display: 'inline-block',

                // width: '300px',
                // backgroundColor: '#cccccc14',
                // borderBottom:'1px solid #ccc',
                padding: '3px 5px',
                // borderRadius: '5px',
                // position: 'absolute',
                // ...targetStyle,
                ...selectStyle,
              },
              on: {
                // 点击
                click: (event)=>{
                  event.preventDefault();
                  event.stopPropagation();
                  // 父级菜单不可点击
                  if (isHasChildren){
                    this.currentDetail = data.row;
                    this.app.on.getList();
                  } else {
                    // 点击标题展开
                    data.expand = !data.expand;
                  }
                },
              },
            }, html);
          },
        },
      },

      // 应用列表
      app: {
        type: 'all',
        total: 0,
        params: {
          page: 1,
          limit: 16,
          // orderSource: this.$route.query.orderSource||'101',
          productType: 2, // 1 产品 2应用
          appClassifyId: '',
        },
        list: [],
        loading: false,
        on: {
          getList: (type)=>{
            this.app.type = type||'';
            if (type==='all'){
              this.currentDetail = {};
            }
            const {
              orderSource,
              corpCode,
            } = this.$store.state.user.userInfo;
            // if (!corpCode){
            //   return;
            // }
            const {id} = this.currentDetail;

            const url = '/paycenter-charge/api/facade/product/app/page';
            // const {appType} = this.$route.query;
            // if (type==='myApp'){
            //   // 如果是我的应用
            //   // url='/paycenter-charge/api/facade/product/my/app';
            //   url='/paycenter-charge/api/worktable/my/app';
            // }
            const params = {
              ...this.app.params,
              orderSource,
              corpCode,
              appClassifyId: id,
            };
            this.app.loading = true;
            this.$http.get(url,params).then(res => {
              this.app.loading = false;
              if (res.success) {
                this.app.list = res.data;
                this.app.total = res.total;
              } else {
                this.$Message.warning(res.message || '商品规格价格计算失败');
              }
            });
          },
          'on-change': (page)=>{
            this.app.params.page =page;
            this.app.on.getList(this.app.type);
          },
          onPageSizeChange: (limit)=>{
            this.app.params.limit = limit;
            this.app.params.page = 1;
            this.app.on.getList(this.app.type);
          },
        },
      },

    };
  },
  computed: {

  },
  created(){
    // 获取应用分类
    this.getClassifyList();
    // 获取列表
    const {appType} = this.$route.query;
    this.app.on.getList(appType||'all');

    // // 头部主体变化事件绑定
    // // 防止多次监听
    // // this.$root.$off('on-corp-change');
    // this.$root.$on('on-corp-change', () => {
    //   // 重新获取已订购的产品
    //   this.app.on.getList();
    // });

  },
  methods: {
    goMyApp(){
      this.$router.push({
        path: '/app/myApp/index',
        // query: {
        //   appType: 'myApp',
        // },
      });
    },
    // 获取应用分类
    getClassifyList() {
      const url = '/paycenter-charge/api/facade/product/listEnable';
      // this.$Spin.show();
      this.$http.get(url).then(res => {
        // this.$Spin.hide();
        if (res.success) {
          // 格式化返回数据
          const data = this.formateMenuTree(res.data,[]);
          this.tree.data = data;
          // this.formateMenuList(res.data)
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 格式化数据
    formateMenuTree(listData, menuTree = []) {
      if (listData.length) {
        listData.forEach((ele) => {

          const tree = {
            title: ele.classifyName,
            expand: false,
            children: [],
            contextmenu: true,
            row: ele,
          };
          if (ele.subList && ele.subList.length) {
            this.formateMenuTree(ele.subList, tree.children);
          }
          menuTree.push(tree);
        });
      }
      return menuTree;
    },
    // 我要订购
    goAppDetail(item){
      // const {corpCode,corpName,orderSource} = this.$route.query;
      this.$router.push({
        path: '/app/appDetail/index',
        query: {
          productCode: item.productCode,
          // corpCode,corpName,orderSource,
        },
      });
    },
    // 订购记录
    goOrderRecord(){
      // const {orderSource,corpCode,corpName} = this.$route.query;
      this.$router.push({
        path: '/app/orderRecord/index',
        query: {
          // orderSource,
          // corpCode,
          // corpName,
        },
      });
    },
    // 续费
    goAppOrder(item){
      // const {productCode,corpCode,corpName} = this.$route.query;
      this.$router.push({
        path: '/app/order/index',
        query: {
          type: 'renew',
          productCode: item.productCode,
          // productCode,
          // corpCode,
          // corpName,
          // skuId: this.selectSkuItem.skuId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.myApp {
  padding: 0 0 10px 20px;
  border-bottom: 1px solid #e5e5e5;
  // font-size: ;
  &.select {
    color: #5e7ce0;
  }
}
.app-side {
  padding-left: 20px;
  .app-all {
    // padding-top: 10px;
    padding-left: 20px;
    cursor: pointer;
  }
  .select {
    color: #5e7ce0;
  }
}
.sider {
  /deep/ .ivu-tree-title {
    &:hover {
      background-color: unset;
    }
  }
  /deep/.ivu-tree-title-selected,
  /deep/ .ivu-tree-title-selected:hover {
    background-color: unset;
  }
  /deep/  .children-title {
    &:hover {
      // background-color: #dfeeff;
      color: #2589ff;
      border-radius: 0;
    }
  }
  /deep/ .ivu-menu-light {
    background-color: transparent;
  }
  /deep/ .ivu-menu-light::after {
    width: 0;
  }
  /deep/ .ivu-menu-light .ivu-menu-item-active::after {
    background-color: transparent;
  }
  // .ivu-menu-opened {
  //   .ivu-menu-submenu-title {
  //     background: #e9edfa;
  //     &::before {
  //       content: "";
  //       display: block;
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 4px;
  //       height: 100%;
  //       background: #e9edfa;
  //     }
  //   }
  // }
}
.page-content {
  // background-color: #fff;
  // padding-top: 10px;
  display: flex;
}
.menu-box {
  // width: 18%;
  width: 224px;
  flex-shrink: 0;
  background-color: #fff;
  padding: 20px 0;
  margin-right: 20px;
  .menu-name {
    font-size: 16px;
    font-weight: bold;
  }
  .go-order-record {
    cursor: pointer;
    color: #490ef4;
    font-size: 12px;
    float: right;
    padding: 2px 0;
  }
}
.page-right {
  // width: 78%;
  flex-shrink: 0;
  width: 956px;
  margin-right: 20px;
  // overflow: hidden;
  // background-color: #fff;
  // padding-bottom: 40px;
  // padding: 20px 10px 40px;
}
.app-box {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  .app-item {
    // display: flex;
    // flex-direction: column;
    cursor: pointer;
    padding-bottom: 40px;
    box-sizing: border-box;
    width: 224px;

    // margin: 0 1%;
    // padding: 0 20px 10px;
    margin-right: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    // border-radius: 5px;
    // box-shadow: 0 0 10px 1px #e7e7e7;
    position: relative;
    overflow: hidden;
    transition: all ease 300ms;
    transform: translateY(0);
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:hover {
      box-shadow: 0 0 15px 1px #ddd;
      // box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);
      transform: translateY(-5px);
    }
    .app-content {
      padding: 0 10px;
    }
    .app-footer {
      position: absolute;
      bottom: 10px;
      left: 10px;
      .app-price {
        font-size: 18px;
        color: #ff455c;
        font-weight: 700;
      }
      .app-price-icon {
        display: inline-block;
        font-size: 12px;
        // margin-right: 4px;
      }
    }
    .app-bottom {
      box-sizing: border-box;
      position: absolute;
      bottom: 10px;
      // width: 100%;
      // left: 20px;
      right: 10px;
    }
    .expire-time {
      color: #999;
      font-size: 12px;
      padding: 5px 0;
      &-red {
        color: #f00;
      }
    }
    .app-img {
      width: 100%;
      height: 120px;
      margin-bottom: 10px;
    }
    .app-name {
      // font-weight: bold;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .app-intro-box {
      margin: 5px 0;
    }
    .app-intro {
      color: #a1a1b3;
      font-size: 12px;
      // margin: 5px 0 30px;
      // 强制两行
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .go-detail {
      color: #490ef4;
      font-size: 12px;
      float: right;
      padding: 2px 0;
    }
    .order-btn {
      width: 100%;
    }
  }
}
.page-box {
  float: right;
  margin-right: 20px;
}

</style>
